import { render, staticRenderFns } from "./update_actions.vue?vue&type=template&id=29d87a7f&scoped=true&"
import script from "./update_actions.vue?vue&type=script&lang=js&"
export * from "./update_actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d87a7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29d87a7f')) {
      api.createRecord('29d87a7f', component.options)
    } else {
      api.reload('29d87a7f', component.options)
    }
    module.hot.accept("./update_actions.vue?vue&type=template&id=29d87a7f&scoped=true&", function () {
      api.rerender('29d87a7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/update_actions.vue"
export default component.exports